import _ from '@lodash';
import XAPPService from 'app/Core/services/XAPPService';
export const GET_EMPRESAPESSOAFOLGAS = '[EMPRESAPESSOAFOLGA APP] GET EMPRESAPESSOAFOLGA';
export const REMOVE_EMPRESAPESSOAFOLGA = '[EMPRESAPESSOAFOLGA APP] REMOVE EMPRESAPESSOAFOLGA';
export const ADD_EMPRESAPESSOAFOLGA = '[EMPRESAPESSOAFOLGA APP] ADD EMPRESAPESSOAFOLGA';
export const EMPRESAPESSOAFOLGA_WARNING = '[EMPRESAPESSOAFOLGA APP] EMPRESAPESSOAFOLGA WARNING';
export const EMPRESAPESSOAFOLGA_INFO = '[EMPRESAPESSOAFOLGA APP] EMPRESAPESSOAFOLGA INFO';
export const EMPRESAPESSOAFOLGA_ERROR = '[EMPRESAPESSOAFOLGA APP] EMPRESAPESSOAFOLGA ERROR';
export const GET_TEMPLATE = '[EMPRESAPESSOAFOLGA APP] GET TEMPLATE';

const listState = [
    'idpessoaformulario',
    'idparent',
    'formulario',
    'statusregistro',
];

const AddState = [
    'idparent',
    'tipo',
    'idpessoa',
    'formulario',
];

export function list(_AAction, _AParams, _AID) {
    return (dispatch) => {
        var AConditionsAND = [
            { "Campo": "idparent", "Operador": "=", "Valor": _AID },
            { "Campo": "tipo", "Operador": "=", "Valor": 134 },
            { "Campo": "pessoaformulario.statusregistro", "Operador": "=", "Valor": 1 }
        ];
        var AConditionsOR = [];
        var AActions = [];
        AActions = XAPPService.XappSelActionFactory(_AParams.empresa, "EmpresaPessoaFolga", AActions, "spvwpessoaformulario", listState, _AAction, AConditionsAND, AConditionsOR)


        XAPPService.XappSelAction(AActions, _AParams, "SEL")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_EMPRESAPESSOAFOLGAS,
                        Name: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].name : "",
                        payload: (response.data && response.data.length > 0) ? JSON.parse(response.data)[0].data : "",
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAFOLGA_ERROR,
                    payload: error
                });
            });
    };
}

export function save(_AValue, _AParams, _AID) {
    return (dispatch) => {

        var AConditionsAND = [];
        var AConditionsOR = [];
        var AActions = [];
        var AAction = "INSERIR";

        if (!_.isUndefined(_AValue.idpessoaformulario) && !_.isNull(_AValue.idpessoaformulario)) {
            AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
            AAction = "ATUALIZAR";
        }

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", AAction, _AValue, "idpessoaformulariorelacionamento", AConditionsAND, AConditionsOR, 1, AddState);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) => {
                if (response.warning) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOAFOLGA_WARNING,
                            payload: response.warning
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
                }
                else if (response.info) {
                    Promise.all([
                        dispatch({
                            type: EMPRESAPESSOAFOLGA_INFO,
                            payload: response.info,
                            id: response.ultimoidinserido
                        })
                    ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
                }
            }).catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAFOLGA_ERROR,
                    payload: error
                });
            });
    };
}

export function getTemplate() {
    return (dispatch) => {

        XAPPService.XappGetTemplateAction('pessoa', "134")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: GET_TEMPLATE,
                        payload: response,
                    })
                ])
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAFOLGA_ERROR,
                    payload: error
                });
            });;
    }
}

export function acaoRegistro(_AValue, _AParams, _AAction, _AID) {
    return (dispatch) => {

        var AConditionsAND = [{ "Campo": "idpessoaformulario", "Operador": "=", "Valor": _AValue.idpessoaformulario }];
        var AConditionsOR = [];
        var AActions = [];

        AActions = XAPPService.XappDoActionFactory(_AParams.empresa, AActions, "pessoaformulario", _AAction, "", "", AConditionsAND, AConditionsOR);

        XAPPService.XappDoAction(AActions, _AParams, "DO")
            .then((response) =>
                Promise.all([
                    dispatch({
                        type: EMPRESAPESSOAFOLGA_INFO
                    })
                ]).then(() => dispatch(list("SELECIONAR", _AParams, _AID)))
            )
            .catch(error => {
                return dispatch({
                    type: EMPRESAPESSOAFOLGA_ERROR,
                    payload: error
                });
            });
    };
}